import React, { useState } from "react";

import Switch from "react-switch";
import JsonEditorView from "./JsonEditorView";
import SingleEditorView from "./SingleEditorView";
import { useConfirmation } from "../common/ConfirmationContext";
import { useToast } from "../common/ToastContext";

const CustomPronunciationModal = ({
  item,
  onEdit,
  onCancel,
  onDelete,
  isAdd = true,
}) => {
  const [isJson, setIsJson] = useState(false);
  const [newPronunciation, setNewPronunciation] = useState({ ...item });
  const [jsonValue, setJsonValue] = useState([
    JSON.stringify(newPronunciation, null, 2),
  ]);
  const [hoveredItem, setHoveredItem] = useState(null);
  const { openConfirmation } = useConfirmation();
  const { showToast } = useToast();

  const handleChange = (e) => {
    const { name, value } = e.target;
    newPronunciation[name] = value;
    setNewPronunciation({ ...newPronunciation });
  };

  const handleJsonChange = (updatedJson) => {
    setJsonValue(updatedJson);
  };

  const handleEditClick = () => {
    let value;
    if (isJson) {
      try {
        value = JSON.parse(jsonValue);
        for (const item of value) {
          if (item.phrase.length > 100) {
            throw new Error(
              "Phrase cannot exceed 100 characters for item: " + item.phrase,
            );
          }
        }
      } catch (error) {
        console.error("Invalid JSON:", error);
        showToast("Invalid JSON format: " + error.message, "error");
        return;
      }
    } else {
      value = newPronunciation;
    }
    onEdit(value);
  };

  const handleDeleteClick = (item) => {
    openConfirmation({
      title: "Confirm Delete",
      message:
        "Are you sure you want to delete this item? This action cannot be undone.",
      onConfirm: () => {
        onDelete(item);
      },
    });
  };

  const handleOnMouseEnter = (item) => {
    setHoveredItem(item);
  };

  const handleOnMouseLeave = () => {
    setHoveredItem(null);
  };

  return (
    <div className="bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-2xl">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-medium mb-2">
          {isAdd ? "Add New" : "Edit"} Custom Pronunciation
        </h3>
        {isAdd ? (
          <div
            onMouseEnter={() => handleOnMouseEnter("json")}
            onMouseLeave={handleOnMouseLeave}
          >
            <Switch
              checked={isJson}
              onChange={(checked) => {
                setIsJson(checked);
              }}
              onColor="#4299e1"
              offColor="#718096"
              height={20}
              width={40}
            />
            {hoveredItem === "json" && (
              <div className="absolute bg-gray-700 text-white text-sm rounded p-2 mt-2 shadow-lg z-10">
                Toggle JSON Editor
              </div>
            )}
          </div>
        ) : null}
      </div>
      <div className="w-full h-64 overflow-y-auto">
        {isJson ? (
          <JsonEditorView
            item={[newPronunciation]}
            onChange={handleJsonChange}
          />
        ) : (
          <SingleEditorView
            item={newPronunciation}
            onChange={handleChange}
            isAdd={isAdd}
            className="h-64"
          />
        )}
      </div>
      <span className="flex justify-end w-full">
        <div className="mr-auto">
          {!isAdd && (
            <button
              onClick={() => handleDeleteClick(newPronunciation)}
              className="mt-4 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            >
              Delete
            </button>
          )}
        </div>
        <div className="ml-auto">
          <button
            onClick={handleEditClick}
            className="mt-4 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
          >
            Save Pronunciation
          </button>
          <button
            onClick={onCancel}
            className="mt-4 ml-2 px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
          >
            Cancel
          </button>
        </div>
      </span>
    </div>
  );
};

export default CustomPronunciationModal;
